<template xmlns="http://www.w3.org/1999/html">
  <div>
    <v-row no-gutters v-if="!isIos && $vuetify.breakpoint.smAndDown && showDownloadAPK" class="download-bar">
      <v-icon @click="hideDownloadBar()" class="mr-2">mdi-close</v-icon>
      <img loading="lazy" class="mr-2" width="30" height="30" src="/static/svg/Bhai88_Logo.png" alt="download" />
      <v-col class="mr-1">
        <label>{{ $t(`label.downloadApp`) }}</label>
      </v-col>
      <app-button title="DOWNLOAD" :action="downloadAPK" :customClass="`download-bar-button subtitle-1`"></app-button>
    </v-row>
    <v-toolbar
      dense
      :class="`full-width header-top elevation-3 ${!isIos && $vuetify.breakpoint.smAndDown && showDownloadAPK ? 'download-bar-height' : ''}`"
      :style="$vuetify.breakpoint.mdAndUp ? 'height: 70px; ' : 'height: 60px'"
    >
      <v-row v-if="$vuetify.breakpoint.smAndDown" class="mobile mobile-top">
        <v-col class="d-flex flex-grow-0 align-center" cols="2">
          <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" height="18" width="22"></v-app-bar-nav-icon>
        </v-col>

        <v-col class="d-flex justify-space-around pt-2">
          <router-link :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }" class="d-flex justify-center align-center">
            <img loading="lazy" width="120px" height="40" src="/static/svg/logo.png" alt="bhai88 logo" />
          </router-link>
        </v-col>

        <v-col v-if="isLoggedIn" class="d-flex align-center mobile-header-rightBtns px-1" cols="4">
          <!--          <v-btn icon color="white" v-if="isLoggedIn&&this.isDAndroid" :plain="true" @click="downloadAPK">-->
          <!--            <img loading="lazy" src="/static/image/home/apkDownload.png" width="32" height="28" :contain="true"/>-->
          <!--          </v-btn>-->
          <!--          <v-btn icon :to="{ name: routeName.INBOX, params: { lang: this.$route.params.lang } }" color="white" v-if="isLoggedIn" :plain="true">-->
          <!--            <v-badge dot bottom left offset-x="5" offset-y="8" :color="hasUnreadInboxMsg ? 'red' : 'transparent'">-->
          <!--              <img loading="lazy" src="/static/svg/Inboxwhite.png" width="32" height="32" :contain="true" />-->
          <!--            </v-badge>-->
          <!--          </v-btn>-->
          <v-col cols="12" class="py-1 pa-0 mobile-balance-holder">
            <label class="text-capitalize balance pr-1" v-if="notLoading">
              <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
              <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
            </label>
            <v-progress-circular indeterminate v-if="!notLoading" color="amber" :width="3" :size="15"></v-progress-circular>
            <v-icon v-if="showBalance" @click="getMemberWallet()" color="white" :size="15" class="mask-balance">mdi-eye-off</v-icon>
            <v-icon v-else @click="getMemberWallet()" color="white" :size="15" class="mask-balance">mdi-eye-settings</v-icon>
            <!--            <v-icon size="15" color="var(&#45;&#45;v-secondary-base)"  @click="getMemberWallet()" class="refresh-balance">-->
            <!--              mdi-refresh-->
            <!--            </v-icon>-->
          </v-col>
        </v-col>
        <v-col v-else cols="3" class="pa-0 d-flex justify-center align-center">
          <v-btn @click="openLanguageDialog()" class="text-capitalize align-self-center white--text invisible-button" :plain="true">
            <v-avatar size="24" class="language-button">
              <img loading="lazy" width="24" height="24" :src="`/static/image/country/${currentCurrency}.svg`" alt="bhai88 exchange" />
            </v-avatar>
            <label>{{ languageSelected }}</label>
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters class="header-top-desktop">
        <v-row class="col" no-gutters>
          <v-row class="self-align" no-gutters justify="start">
            <router-link :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }" class="d-flex justiy-center">
              <img loading="lazy" width="210px" height="70" src="/static/svg/logo.png" alt="bhai88 logo" />
            </router-link>
          </v-row>

          <v-row no-gutters justify="end" class="header-column">
            <div v-if="isLoggedIn" class="is-login-header">
              <img loading="lazy" class="btn-icon" width="28px" height="28px" src="/static/svg/mobileBottomNavigation/toolbar-profile.png" alt="profile" @click="goToProfilePage" />
              <v-badge dot right offset-x="8" offset-y="8" :color="hasUnreadInboxMsg ? 'red' : 'transparent'">
                <img loading="lazy" class="btn-icon" width="28px" height="28px" src="/static/svg/Inboxwhite.png" alt="inbox" @click="goToInboxPage" />
              </v-badge>
              <div class="header-divider"></div>
              <label>{{ $t(`label.mainWallet`) }}</label>
              <label class="text-capitalize balance" v-if="notLoading">
                <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
                <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
              </label>
              <v-progress-circular indeterminate v-if="!notLoading" color="amber" :width="3" :size="24"></v-progress-circular>
              <v-icon v-if="showBalance" @click="getMemberWallet()" color="white" :size="24" class="mask-balance">mdi-eye-off</v-icon>
              <v-icon v-else @click="getMemberWallet()" color="white" :size="24" class="mask-balance">mdi-eye-settings</v-icon>
              <!--              <v-icon size="20" color="var(&#45;&#45;v-secondary-base)" @click="getMemberWallet()" class="refresh-balance">-->
              <!--                mdi-refresh-->
              <!--              </v-icon>-->
              <button-primary class="deposit-button" :action="() => goToDepositPage()" :title="$t('label.deposit')"></button-primary>
              <div @click="logout">
                <label class="invisible-button">{{ $t(`label.logout`) }}</label>
              </div>
            </div>
            <app-login-embedded
              v-if="!isLoggedIn"
              :openRegisterDialog="this.openRegisterDialog"
              :openLoginDialog="this.openLoginDialog"
              :openLanguageDialog="this.openLanguageDialog"
            ></app-login-embedded>

            <v-btn @click="openLanguageDialog()" class="text-capitalize align-self-center white--text invisible-button" :plain="true">
              <v-avatar size="24" class="language-button">
                <img loading="lazy" width="24" height="24" :src="`/static/image/country/${currentCurrency}.svg`" alt="bhai88 exchange" />
              </v-avatar>
              <label>{{ languageSelected }} {{ $t(`language.${currentLanguage}`) }}</label>
            </v-btn>
          </v-row>
        </v-row>
      </v-row>
    </v-toolbar>

    <v-navigation-drawer v-if="$vuetify.breakpoint.smAndDown" class="side-navigation-drawer" v-model="drawer" fixed left temporary width="380px">
      <v-list nav class="mobile_list_menu">
        <v-list-item-group active-class="">
          <v-list-item class="side-nav-logo">
            <!--            :style="{ transform: imageRotation }"-->
            <v-row no-gutters>
              <v-col cols="2" class="pa-0">
                <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" height="18" width="22"></v-app-bar-nav-icon>
              </v-col>
              <v-col cols="10" class="pa-0 d-flex justify-center align-center">
                <img @click="gotoHomePage()" style="margin-right: 60px;" width="120px" height="30" src="/static/svg/logo.png" alt="bhai88 logo" />
              </v-col>
            </v-row>
            <!--            <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" height="14" width="24"></v-app-bar-nav-icon>-->

            <!--            <img style="margin-left: auto; transform: rotate(0deg); transition: transform 0.3s;" src="/static/svg/right-arrows_w.png" @click.stop="rotateImage" height="20" width="20" />-->
          </v-list-item>
          <div class="" :class="isLoggedIn ? 'side-navigation-banner-login' : 'side-navigation-banner'">
            <v-row no-gutters class="d-block" v-if="!isLoggedIn">
              <v-col cols="12" class="pa-0 d-block">
                <v-col cols="12" class="pa-0 text-center">
                  <label class="white--text starterPackText">{{ $t(`label.startPackTitle1`) }}</label>
                </v-col>
                <v-col cols="12" class="pa-0 text-center">
                  <label class="white--text starterPackTextSmall">{{ $t(`label.startPackTitle2`) }}</label>
                </v-col>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-btn class="side-navigation-banner-button" @click="goToPromoPage()">
                  {{ $t(`button.instantGetNow`) }}
                </v-btn>
              </v-col>
              <v-col cols="12" class="pa-0 text-center">
                <label class="starterPackTextSmall white--text">{{ $t(`label.alreadyHaveAccount`) }}</label>
                <label class="starterPackTextSmall white--text" @click="openLoginDialog()">{{ $t(`button.loginNow`) }}</label>
              </v-col>
            </v-row>
          </div>
          <!--          <v-list-item :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }">-->
          <!--            <v-row no-gutters class="list-item-container">-->
          <!--              <v-list-item-icon class="side-menu-icon-wrapper">-->
          <!--                <img loading="lazy" src="../../assets/svg/side nav/refer.png" height="42" width="42" alt="bhai88 referral" class="side-menu-icon" />-->
          <!--              </v-list-item-icon>-->
          <!--              <v-list-item-content>-->
          <!--                <v-list-item-title style="padding-left: 7px">-->
          <!--                  <v-row no-gutters justify="start" align="center">-->
          <!--                    <v-col cols="auto" class="mt-1 breakWord-onspace">{{ $t(`label.referral`) }}</v-col>-->
          <!--                    <div class="text-center" style="margin-left: 2px; background-color: #04b22b; border-radius: 8px; color: white; font-size: 10px;width:30px">-->
          <!--                      <span class="font-weight-bold">{{ $t(`label.best`) }}</span>-->
          <!--                    </div>-->
          <!--                  </v-row>-->
          <!--                </v-list-item-title>-->
          <!--              </v-list-item-content>-->
          <!--              <v-icon>mdi-chevron-right-circle</v-icon>-->
          <!--            </v-row>-->
          <!--          </v-list-item>-->

          <!--          <v-list-item :to="{ name: routeName.APPLY_AGENT, params: { lang: this.$route.params.lang } }">-->
          <!--            <v-row no-gutters class="list-item-container">-->
          <!--              <v-list-item-icon class="side-menu-icon-wrapper">-->
          <!--                <img loading="lazy" src="../../assets/svg/side nav/Affiliate.png" height="42" width="42" alt="bhai88 referral" class="side-menu-icon" />-->
          <!--              </v-list-item-icon>-->
          <!--              <v-list-item-content>-->
          <!--                <v-list-item-title style="padding-left: 7px">-->
          <!--                  <v-row no-gutters justify="start" align="center">-->
          <!--                    <v-col cols="auto" class="mt-1 breakWord-onspace">{{ $t(`label.affiliate`) }}</v-col>-->
          <!--                    &lt;!&ndash;                    <div class="text-center" style="margin-left: 2px; background-color: #04b22b; border-radius: 8px; color: white; font-size: 10px;width:30px">&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      <span class="font-weight-bold">{{ $t(`label.new`) }}</span>&ndash;&gt;-->
          <!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                  </v-row>-->
          <!--                </v-list-item-title>-->
          <!--              </v-list-item-content>-->
          <!--              <v-icon>mdi-chevron-right-circle</v-icon>-->
          <!--            </v-row>-->
          <!--          </v-list-item>-->
          <!--          <v-list-item :to="{ name: routeName.PROMOTION, params: { lang: this.$route.params.lang } }" class="list-item-standalone">-->
          <!--            <v-row no-gutters class="list-item-container">-->
          <!--              <v-list-item-icon class="side-menu-icon-wrapper">-->
          <!--                <img loading="lazy" src="../../assets/svg/side nav/promotion.png" height="41" width="41" alt="bhai88 promotion" class="side-menu-icon" />-->
          <!--              </v-list-item-icon>-->
          <!--              <v-list-item-content>-->
          <!--                <v-list-item-title style="padding-left: 7px">{{ $t(`label.promotion`) }}</v-list-item-title>-->
          <!--              </v-list-item-content>-->

          <!--              &lt;!&ndash;                  <v-btn>&ndash;&gt;-->
          <!--              <v-icon>mdi-chevron-right-circle</v-icon>-->
          <!--              &lt;!&ndash;                  </v-btn>&ndash;&gt;-->
          <!--            </v-row>-->
          <!--          </v-list-item>-->
          <!--          <v-list-item :to="{ name: routeName.VIPTIER, params: { lang: this.$route.params.lang } }">-->
          <!--            <v-row no-gutters class="list-item-container">-->
          <!--              <v-list-item-icon class="side-menu-icon-wrapper">-->
          <!--                <img loading="lazy" src="/static/svg/mobileMenu/viptier.png" height="42" width="42" alt="bhai88 referral" class="side-menu-icon" />-->
          <!--              </v-list-item-icon>-->
          <!--              <v-list-item-content>-->
          <!--                <v-list-item-title style="padding-left: 7px">{{ $t(`label.viptier`) }}</v-list-item-title>-->
          <!--              </v-list-item-content>-->
          <!--              <v-icon>mdi-chevron-right-circle</v-icon>-->
          <!--            </v-row>-->
          <!--          </v-list-item>-->
          <!--          <v-list-item :to="{ name: routeName.VIP, params: { lang: this.$route.params.lang } }">-->
          <!--            <v-row no-gutters class="list-item-container">-->
          <!--              <v-list-item-icon>-->
          <!--                <img loading="lazy" src="../../assets/svg/side nav/Nagad88 Ladderboard.png" height="42" width="42" class="side-menu-icon" />-->
          <!--              </v-list-item-icon>-->
          <!--              <v-list-item-content>-->
          <!--                <v-list-item-title style="padding-left: 7px">-->
          <!--                  <v-row no-gutters justify="start" align="center">-->
          <!--                    <v-col cols="auto" class="mt-1 breakWord-onspace">{{ $t(`label.bettingPassNavName`) }}</v-col>-->
          <!--                    &lt;!&ndash;                    <div class="text-center" style="margin-left: 2px; background-color: #04b22b; border-radius: 8px; color: white; font-size: 10px;width:30px">&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      <span class="font-weight-bold">{{ $t(`label.new`) }}</span>&ndash;&gt;-->
          <!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                  </v-row>-->
          <!--                </v-list-item-title>-->
          <!--              </v-list-item-content>-->
          <!--              <v-icon>mdi-chevron-right-circle</v-icon>-->
          <!--            </v-row>-->
          <!--          </v-list-item>-->

          <!--          <hr />-->

          <div class="box">
            <!--            <item>-->
            <v-list-item class="sidenav icon mb-0" style="width: 200px" @click="gotoHomePage()" exact>
              <v-col>
                <v-row class="align-content-center" style="display: block; text-align-last: center">
                  <v-list-item-icon>
                    <img loading="lazy" src="/static/svg/mobileMenu/Home.svg" height="30px" width="30px" alt="bhai88 cricket" class="side-menu-icon" />
                  </v-list-item-icon>
                </v-row>
                <v-row>
                  <v-list-item-content class="text-center pt-1">
                    <v-list-item-title style="font-size: 14px">{{ $t(`label.home`) }}</v-list-item-title>
                  </v-list-item-content>
                </v-row>
              </v-col>
            </v-list-item>
            <v-list-item class="sidenav icon " style="width: 200px" v-for="gameType in storageGameProviderType" :key="gameType.type" :to="getListItemTo(gameType)" exact>
              <v-row class="align-content-center" style="display: block">
                <v-list-item-icon class="side-menu-icon-wrapper">
                  <img :src="`/static/svg/mobileMenu/${gameType.type}.svg`" class="side-menu-icon" :alt="`${gameType.type}`" />
                </v-list-item-icon>
                <v-list-item-content class="text-center pt-1">
                  <v-list-item-title style="font-size: 14px">{{ $t(`label.${gameType.type}`) }}</v-list-item-title>
                </v-list-item-content>
              </v-row>
            </v-list-item>
            <v-list-item class="sidenav icon" style="width: 200px" :to="{ name: routeName.PROMOTION, params: { lang: this.$route.params.lang } }" exact>
              <v-col>
                <v-row class="align-content-center" style="display: block; text-align-last: center">
                  <v-list-item-icon>
                    <img loading="lazy" src="/static/svg/mobileMenu/promotion.svg" height="30px" width="30px" alt="bhai88 cricket" class="side-menu-icon" />
                  </v-list-item-icon>
                </v-row>
                <v-row>
                  <v-list-item-content class="text-center pt-1">
                    <v-list-item-title style="font-size: 14px">{{ $t(`label.promo`) }}</v-list-item-title>
                  </v-list-item-content>
                </v-row>
              </v-col>
            </v-list-item>
            <!--<<<<<<< Updated upstream-->
            <!--=======-->
            <!--            </item>-->
            <!--&lt;!&ndash;            3rd row&ndash;&gt;-->
            <!--            <item>-->
            <!--              <v-list-item :to="{ name: routeName.TABLE_GAMES }">-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block"-->
            <!--                    <v-list-item-icon>-->
            <!--                      <img loading="lazy" src="../../assets/svg/side nav/casino.png" height="42" width="42"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center">-->
            <!--                      <v-list-item-title style="font-size: 14px"> {{ $t(`label.table`) }} </v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->
            <!--            <item>-->
            <!--              <v-list-item> &lt;!&ndash;Crash&ndash;&gt;-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block">-->
            <!--                    <v-list-item-icon>-->
            <!--                      <img loading="lazy" src="../../assets/svg/side nav/plane.png" height="42" width="42"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center">-->
            <!--                      <v-list-item-title style="font-size: 14px"> {{ $t(`label.crash`) }} </v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->
            <!--            <item> </item>-->
            <!--       for language    <v-list-item-content :class="['pl-1', isLoggedIn ? 'pt-0' : '']">-->
            <!--&gt;>>>>>> Stashed changes-->
          </div>
          <div class="secBox">
            <!--            <item>-->
            <v-list-item class="sidenav icon" :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }" exact>
              <v-col class="pa-0">
                <v-row no-gutters class="align-start">
                  <v-list-item-icon>
                    <img loading="lazy" src="/static/svg/mobileMenu/Referral.svg" height="30px" width="30px" alt="bhai88 cricket" class="side-menu-icon" />
                    <v-list-item-title style="font-size: 14px">{{ $t(`label.referral`) }}</v-list-item-title>
                  </v-list-item-icon>
                </v-row>
              </v-col>
            </v-list-item>
            <!--            <v-list-item v-if="false" class="sidenav icon" :to="{ name: routeName.APPLY_AGENT, params: { lang: this.$route.params.lang } }" exact>-->
            <!--              <v-col class="pa-0">-->
            <!--                <v-row no-gutters class="align-start">-->
            <!--                  <v-list-item-icon>-->
            <!--                    <img loading="lazy" src="/static/svg/mobileMenu/affiliate.svg" height="30px" width="30px" alt="bhai88 cricket" class="side-menu-icon" />-->
            <!--                    <v-list-item-title style="font-size: 14px">{{ $t(`label.affiliate`) }}</v-list-item-title>-->
            <!--                  </v-list-item-icon>-->
            <!--                </v-row>-->
            <!--              </v-col>-->
            <!--            </v-list-item>-->
            <v-list-item v-if="false" class="sidenav icon" :to="{ name: routeName.VIP, params: { lang: this.$route.params.lang } }" exact>
              <v-col class="pa-0">
                <v-row no-gutters class="align-start">
                  <v-list-item-icon>
                    <img loading="lazy" src="/static/svg/mobileMenu/leaderboard.svg" height="30px" width="30px" alt="bhai88 cricket" class="side-menu-icon" />
                    <v-list-item-title style="font-size: 14px">{{ $t(`label.bettingPassNavName`) }}</v-list-item-title>
                  </v-list-item-icon>
                </v-row>
              </v-col>
            </v-list-item>
            <v-list-item class="sidenav icon" :to="{ name: routeName.VIPTIER, params: { lang: this.$route.params.lang } }" exact>
              <v-col class="pa-0">
                <v-row no-gutters class="align-start">
                  <v-list-item-icon>
                    <img loading="lazy" src="/static/svg/mobileMenu/VIP.svg" height="30px" width="30px" alt="bhai88 cricket" class="side-menu-icon" />
                    <v-list-item-title style="font-size: 14px">{{ $t(`label.viptier`) }}</v-list-item-title>
                  </v-list-item-icon>
                </v-row>
              </v-col>
            </v-list-item>
            <!--<<<<<<< Updated upstream-->
            <!--=======-->
            <!--            </item>-->
            <!--&lt;!&ndash;            3rd row&ndash;&gt;-->
            <!--            <item>-->
            <!--              <v-list-item :to="{ name: routeName.TABLE_GAMES }">-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block"-->
            <!--                    <v-list-item-icon>-->
            <!--                      <img loading="lazy" src="../../assets/svg/side nav/casino.png" height="42" width="42"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center">-->
            <!--                      <v-list-item-title style="font-size: 14px"> {{ $t(`label.table`) }} </v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->
            <!--            <item>-->
            <!--              <v-list-item> &lt;!&ndash;Crash&ndash;&gt;-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block">-->
            <!--                    <v-list-item-icon>-->
            <!--                      <img loading="lazy" src="../../assets/svg/side nav/plane.png" height="42" width="42"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center">-->
            <!--                      <v-list-item-title style="font-size: 14px"> {{ $t(`label.crash`) }} </v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->
            <!--            <item> </item>-->
            <!--       for language    <v-list-item-content :class="['pl-1', isLoggedIn ? 'pt-0' : '']">-->
            <!--&gt;>>>>>> Stashed changes-->
          </div>
          <v-list-item class="pt-4 mb-0" @click="goToClaimVoucherPage()">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img loading="lazy" src="/static/svg/mobileMenu/Rewards.png" alt="bhai88 rewards" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.extraRewards`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-if="false" @click="goToVideoGuidePage()">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img loading="lazy" src="/static/svg/mobileMenu/guide.svg" alt="bhai88 cricket exchange" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.videoGuide`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
          <v-divider class="side-navigation-divider"></v-divider>
          <v-list-item class="mb-0" @click="openLanguageDialog()">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img loading="lazy" src="/static/svg/mobileMenu/language.png" alt="bhai88 cricket exchange" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.language`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
          <v-divider class="side-navigation-divider"></v-divider>
          <v-list-item class="mb-0" href="javascript:void(0);" @click="showIntercomLC">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img loading="lazy" src="/static/svg/mobileMenu/livechat.png" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.customerService`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
          <v-divider class="side-navigation-divider"></v-divider>
          <v-list-item class="mb-0" @click="downloadAPK" v-if="this.isDAndroid">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img loading="lazy" src="/static/svg/mobileMenu/apkDownload.png" alt="bhai88 apk" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.download`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
          <v-divider v-if="isLoggedIn" class="side-navigation-divider"></v-divider>
          <v-list-item @click="logout" v-if="isLoggedIn">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img loading="lazy" src="/static/svg/mobileMenu/logout.png" alt="bhai88 crazytime exchange" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.logout`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <app-page-navigator></app-page-navigator>

    <div :class="`body ${!isIos && $vuetify.breakpoint.smAndDown && showDownloadAPK ? 'download-bar-height-body' : ''}`">
      <router-view></router-view>
      <app-footer></app-footer>
    </div>

    <div v-if="$vuetify.breakpoint.smAndDown" class="bottom-navigator">
      <v-row no-gutters v-if="false" class="bottom-navigator-before-login">
        <v-col cols="4" @click="openLanguageDialog()" class="bottom-navigator-before-login-first d-flex flex-row justify-center align-center no-gutters">
          <div class="d-flex flex-column justify-center align-center">
            <v-btn icon small>
              <v-avatar size="25" class="language-button">
                <img loading="lazy" width="25" height="25" :src="`/static/image/country/${currentCurrency}.svg`" alt="bhai88 cricket exchange" />
              </v-avatar>
            </v-btn>
          </div>
          <div no-gutters class="d-flex flex-column justify-center align-center">
            <span style="font-weight: bolder; font-size: 12px; padding-left: 10px;">{{ languageList[0].currencyCd }} {{ languageList[0].currency }}</span>
            <span style=" font-weight: bolder; font-size: 12px; padding-left: 10px;">
              {{ $t(`language.${currentLanguage}`) }}
            </span>
            <!--            <span v-for="l in language" :key="l.id" style="font-size: 12px">{{ l.title }}</span>-->
          </div>
        </v-col>
        <v-col cols="4" @click="openLoginDialog()" class="bottom-navigator-before-login-third d-flex justify-center align-center no-gutters">
          <b>{{ $t(`label.login`) }}</b>
        </v-col>
        <v-col cols="4" @click="this.openRegister" class="bottom-navigator-before-login-second d-flex justify-center align-center no-gutters">
          <b>{{ $t(`label.register`) }}</b>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="isLoggedIn">
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" exact exact-active-class="link-active" :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }">
            <div class="text-center">
              <img loading="lazy" class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-home.png`" alt="home" />
              <p class="bottom-navigator-text">{{ $t(`label.home`) }}</p>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" exact exact-active-class="link-active" :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }">
            <div class="text-center">
              <img loading="lazy" class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-referral.png`" alt="referral" />
              <p class="bottom-navigator-text">{{ $t(`label.referral`) }}</p>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-row class="cols" style="justify-content:center">
            <router-link
              class="bottom-navigation-center-button "
              :to="{ name: routeName.DEPOSIT, params: { lang: this.$route.params.lang } }"
              style="line-height: .7; align-items: center;
                         justify-content: center;
                         display: flex; padding-left: 8px !important;"
            >
              <div class="text-center">
                <img loading="lazy" class="icon_btm_nav" style="height: 35px;width: 35px;" :src="`/static/svg/mobileBottomNavigation/toolbar-newdepositicon.png`" alt="deposit" />
              </div>

              <!--            <img loading="lazy" class="icon_btm_nav depo_icon_btm_nav"-->
              <!--                 :src="`/static/svg/mobileBottomNavigation/toolbar-newdepositicon.png`" alt="deposit"/>-->
              <!--            <p>{{ $t(`label.deposit`) }}</p>-->
              <!--            <div>{{ $t(`label.deposit`) }}</div>-->
            </router-link>
          </v-row>
          <v-row
            class="white--text cols"
            style=" align-items: center;
                         justify-content: center;
                         display: flex; height: 45%;"
          >
            <span class="bottom-navigator-text middledeposit">{{ $t(`label.deposit`) }}</span>
          </v-row>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" exact exact-active-class="link-active" :to="{ name: routeName.PROMOTION, params: { lang: this.$route.params.lang } }">
            <div class="text-center">
              <img loading="lazy" class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-promotion.png`" alt="promotion" />
              <p class="bottom-navigator-text">{{ $t(`label.promotion`) }}</p>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" to="#" @click="openProfileSheet">
            <div class="text-center">
              <img loading="lazy" class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-profile.png`" alt="bhai88 crazytime exchange" />
              <p class="bottom-navigator-text">{{ $t(`label.profile`) }}</p>
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <profile-sheet :showProfileSheet="showProfileSheet" :closeProfileSheet="closeProfileSheet" :logout="logout"></profile-sheet>

    <app-floating-reward></app-floating-reward>
    <app-floating-contactUs></app-floating-contactUs>

    <!-- WAIT REGISTER DIALOG -->
    <app-dialog :dialogShow="waitRegisterDialogShow" :max-width="600" :title="$t(`label.wait`)" :closeAction="closeWaitRegisterDialog">
      <app-wait-register :openRegisterDialog="openRegisterDialog" :openLoginDialog="openLoginDialog"></app-wait-register>
    </app-dialog>

    <!-- REGISTER DIALOG -->
    <!--    <app-dialog :dialogShow="registerDialogShow" :max-width="400" :min-height="724" :title="$t(`label.signUp`)"-->
    <!--                :isAuth="false" :header_title="'register'" :openLoginDialog="openLoginDialog"-->
    <!--                :closeAction="this.closeRegisterDialog">-->
    <!--      <app-register :openLoginDialog="this.openLoginDialog" :registerErrorMsg="this.registerErrorMsg"></app-register>-->
    <!--    </app-dialog>-->

    <app-dialog
      :dialogShow="registerDialogShow"
      :max-width="400"
      :min-height="724"
      :title="$t(`label.joininregister`)"
      :isAuth="false"
      :header_title="'register'"
      :openLoginDialog="openLoginDialog"
      :closeAction="this.closeRegisterDialog"
    >
      <app-register :openLoginDialog="this.openLoginDialog" :registerErrorMsg="this.registerErrorMsg"></app-register>
    </app-dialog>
    <!-- FORGOT PASSWORD DIALOG -->
    <app-dialog :dialogShow="forgotPasswordDialogShow" :max-width="400" :title="$t(`label.forgotPassword`).slice(0, -1)" :closeAction="this.closeForgotPasswordDialog" :customClass="'pa-0'">
      <app-forgot-password :openRegisterDialog="openRegisterDialog" :openLoginDialog="this.openLoginDialog"></app-forgot-password>
    </app-dialog>

    <!-- RESET PASSWORD DIALOG -->
    <app-dialog :dialogShow="resetPasswordDialogShow" :max-width="400" :title="$t(`label.resetPassword`)" :closeAction="this.closeResetPasswordDialog">
      <app-reset-password :resetPasswordMemberCode="resetPasswordObj.memberCode" :resetPasswordContact="resetPasswordObj.contact"></app-reset-password>
    </app-dialog>

    <!-- LOGIN DIALOG -->
    <app-dialog
      :dialogShow="loginDialogShow"
      ref="loginDialog"
      :max-width="400"
      :title="$t(`label.welcomeToBrand`)"
      :isAuth="false"
      :header_title="'login'"
      :openRegisterDialog="openRegisterDialog"
      :closeAction="this.closeLoginDialog"
      :customClass="'pa-0'"
    >
      <app-login
        :openRegisterDialog="this.openRegisterDialog"
        :loginErrorMsg="this.loginErrorMsg"
        :openForgotPasswordDialog="this.openForgotPasswordDialog"
        :closeAction="this.closeLoginDialog"
      ></app-login>
    </app-dialog>

    <!-- NEW REGISTER DIALOG -->
    <app-dialog :dialogShow="newRegisterDialogShow" ref="newRegisterDialog" :max-width="400" :title="$t(`label.newRegisterSuccess`)" :closeAction="this.closeNewRegisterDialogShow">
      <app-new-register :closeNewRegisterDialog="closeNewRegisterDialogShow"></app-new-register>
    </app-dialog>

    <!-- REGISTER SUCCESS DIALOG -->
    <app-dialog
      :dialogShow="registerSuccessDialogShow"
      :isRegSuccess="true"
      ref="registerSuccessDialog"
      :max-width="400"
      :title="$t(`label.registerSuccess`)"
      :closeAction="this.closeRegisterSuccessDialog"
    >
      <app-register-success :closeRegisterSuccessDialog="closeRegisterSuccessDialog"></app-register-success>
    </app-dialog>

    <!--PT Quick Transfer Dialog-->
    <app-dialog :dialogShow="quickTransferDialogShow" :max-width="450" :title="this.transferMessage" :closeAction="this.closeQuickTransferDialog">
      <app-transfer-component :isNonBanking="true" :provider="this.transferToProvider" :ptGameInfo="this.ptGameInfo"></app-transfer-component>
    </app-dialog>

    <!-- PAGE DIALOG -->
    <app-dialog :dialogShow="pageDialogShow" :max-width="400" :title="pageDialog.title" :closeAction="this.pageDialog.dialogXButton">
      <app-page-dialog
        :dialogMessageTitle="pageDialog.messageTitle"
        :dialogMessage="pageDialog.message"
        :dialogButton="pageDialog.button"
        :dialog-attachments="pageDialog.attachment"
      ></app-page-dialog>
    </app-dialog>

    <!-- INSTANT POPUP DIALOG -->
    <instant-popup-dialog :dialog-show="instantDialogShow" :max-width="438" :closeAction="this.closeInstantPopup" :array-info="popupAnnouncement"></instant-popup-dialog>

    <!-- LANGUAGE DIALOG -->
    <app-dialog
      :dialogShow="languageDialogShow"
      ref="languageDialog"
      :max-width="300"
      :title="$t(`label.currencyLanguage`)"
      :isAuth="false"
      :header_title="'login'"
      :closeAction="this.closeLanguageDialog"
      :customClass="'pa-0'"
    >
      <app-language :closeAction="this.closeLanguageDialog"></app-language>
    </app-dialog>
    <!--    <app-dialog :dialogShow="languageDialogShow" ref="languageDialog" :max-width="450" :title="'Currency and Language'"-->
    <!--                :isAuth="false" :header_title="'login'" :closeAction="this.closeLanguageDialog">-->
    <!--      <app-language :closeAction="this.closeLanguageDialog"></app-language>-->
    <!--    </app-dialog>-->
    <instant-login-popup-dialog :dialog-show="instantLoginDialogShow" :max-width="438" :closeAction="this.closeInstantLoginPopup" :array-info="loginPopupAnnouncement"></instant-login-popup-dialog>
    <!--    <app-loading-progress ref="loading"></app-loading-progress>-->
    <app-loading-progress ref="loading"></app-loading-progress>
  </div>
</template>

<script>
import '@mdi/font/css/materialdesignicons.css'
import moment from 'moment'
import { GRAB_COIN_SETTING } from '@/store/bonus.module'
import AccountLiveChat from '@/assets/svg/liveChat.svg'
import AppTransferComponent from '@/views/bank/transfer'
import AccountProfile from '@/assets/svg/account-profile.svg'
import AccountWallet from '@/assets/svg/account-deposit.svg'
import AccountWithdrawal from '@/assets/svg/account-withdrawal.svg'
import AccountHistory from '@/assets/svg/account-history.svg'
import AppFloatingReward from '@/components/home/FloatingReward.vue'
import AppFloatingContactUs from '@/components/home/FloatingContactUs.vue'
import NavTransfer from '@/assets/svg/transfer.svg'
import NavDeposit from '@/assets/svg/deposit.svg'
import NavWithdrawal from '@/assets/svg/withdrawal.svg'
import NavLogout from '@/assets/svg/logout.svg'
import vipIcon from '@/assets/svg/vip.svg'
import InstantPopupDialog from '@/components/InstantPopupDialog.vue'

import { AnnouncementType, DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
// import AppRegisterFromAF from '@/views/defaultregister.vue'
import AppRegister from '@/views/register.vue'
import AppRegisterSuccess from '@/components/member/registerSuccess.vue'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import AppWaitRegister from '@/components/member/waitRegister.vue'
import AppForgotPassword from '@/components/member/forgotPassword.vue'
import AppResetPassword from '@/components/member/resetPassword.vue'
import AppPageDialog from '@/components/layout/PageDialog.vue'
import AppPageNavigator from '@/components/layout/PageNavigator.vue'
import AppFooter from '@/components/layout/Footer.vue'
import AppLoadingProgress from '@/components/layout/LoadingProgress.vue'
import AppLogin from '@/components/member/login.vue'
import AppLanguage from '@/components/layout/Language.vue'
import AppNewRegister from '@/components/member/newRegister.vue'
import { SESSION, SHARED, CACHE_KEY } from '@/constants/constants'
import { locale, errorCodeHelper, uiHelper } from '@/util'
import InstantLoginPopupDialog from '@/components/InstantLoginPopupDialog'
import {
  MEMBER_RESET_LOGOUT_STORE,
  MEMBER_RESET_LOGIN_STORE,
  MEMBER_LOGOUT,
  MEMBER_REFRESH_TOKEN,
  MEMBER_RESET__STORE,
  MEMBER_CHECK_TOKEN_VALIDITY,
  MEMBER_WALLET,
  MEMBER_RESET_FORGOT_PASSWORD_STORE,
  MEMBER_RESET_RESET_PASSWORD_STORE,
  MEMBER_CONTACT_VERIFICATION,
  MEMBER_RESET_CONTACT_VERIFICATION_STORE,
  MEMBER_RESET_REGISTER_STORE,
  MEMBER_GET_VIP_PROGRESS,
  MEMBER_RESET_SMS_VERIFICATION,
  ONE_SIGNAL_PLAYER_IDS,
  ONE_SIGNAL_PLAYER_IDS_RESET_STORE,
  MEMBER_RESET_UPDATE_FORGOT_PASSWORD
} from '@/store/member.module'
import { LOGIN_POPUP_LIST, POPUP_LIST } from '@/store/announcement.module'
import { WHEEL_MODULE } from '@/store/wheel.module'
import { INBOX_GET_MSG } from '@/store/inbox.module'
import ButtonPrimary from '../ButtonPrimary.vue'
import OneSignalVue from 'onesignal-vue'
import { MEMBER_RESET_STORE_REG_ID, MEMBER_STORE_REG_ID } from '../../store/member.module'
import { GET_FACEBOOK_PIXEL, POST_CHANNEL_PAGE_VIEW } from '@/store/facebookpixel.module'

export default {
  name: 'layoutMaster',
  components: {
    InstantLoginPopupDialog,
    // AppRegisterFromAF,
    AccountLiveChat,
    AppTransferComponent,
    AccountProfile,
    AccountWallet,
    AccountWithdrawal,
    AccountHistory,
    AppLogin,
    AppLanguage,
    AppRegister,
    AppRegisterSuccess,
    AppNewRegister,
    AppLoginEmbedded,
    AppForgotPassword,
    AppResetPassword,
    AppPageDialog,
    AppPageNavigator,
    AppFooter,
    AppLoadingProgress,
    AppWaitRegister,
    AppFloatingReward,
    AppFloatingContactUs,
    NavDeposit,
    NavWithdrawal,
    NavLogout,
    NavTransfer,
    vipIcon,
    InstantPopupDialog,
    ButtonPrimary
  },
  data: () => ({
    instantLoginDialogShow: false,
    showBalance: true,
    regionLocale: uiHelper.getRegionLocale(),
    imageRotation: 'rotate(0deg)',
    selectedGameType: null,
    googleURL: 'www.google.com',
    playerIds: '',
    showDownloadAPK: true,
    isIos: uiHelper.IsIos(),
    isDAndroid: uiHelper.isAndroid(),
    showProfileSheet: false,
    time: '',
    instantDialogShow: false,
    instantPopupAnnouncement: [],
    drawer: false,
    notLoading: true,
    currentLanguage: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    transferMessage: locale.getMessage(`label.ptQuickTransfer`, ['PT']),
    isTransferWalletLoginDialog: false,
    ptGameInfo: null,
    transferToProvider: 'PT',
    devicePlatform: DevicePlatform,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    uihelper: uiHelper,
    quickTransferDialogShow: false,
    registerSuccessDialogShow: false,
    newRegisterDialogShow: false,
    waitRegisterDialogShow: false,
    registerDialogShow: false,
    loginDialogShow: false,
    forgotPasswordDialogShow: false,
    resetPasswordDialogShow: false,
    languageDialogShow: false,
    firstTimeRegister: true,
    routeName: ROUTE_NAME,
    resetPasswordObj: {
      contact: '',
      memberCode: ''
    },
    pageDialogShow: false,
    pageDialog: {
      title: '',
      closePageDialog: () => {},
      messageTitle: '',
      message: [],
      button: []
    },
    memberLink: SHARED.MEMBER_HEADER_NAVIGATOR_LINK,
    loginErrorMsg: '',
    registerErrorMsg: '',
    language: [
      {
        title: 'English',
        cd: 'en'
      },
      {
        title: 'Bengali',
        cd: 'bd'
      }
    ],
    languageList: [
      {
        currency: 'BDT',
        currencyCd: '৳',
        img: 'BDT',
        language: [
          {
            title: 'English',
            cd: 'en'
          },
          {
            title: 'Bengali',
            cd: 'bd'
          }
        ]
      }
    ]
  }),
  computed: {
    facebookPixels() {
      return this.$store.state.facebookPixel.facebookPixels
    },
    loginPopupAnnouncement() {
      let p = []
      let k = this.$store.state.announcement.popupLoginAnnouncement
      k.forEach(announcement => {
        p.push({
          id: announcement.id,
          date: announcement.announcementDate,
          title:
            announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
              : announcement.titleLocale.find(x => x.language == 'en') != null
              ? announcement.titleLocale.find(x => x.language == 'en').title
              : announcement.titleLocale[0].title,
          message:
            announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
              : announcement.messageLocale.find(x => x.language == 'en') != null
              ? announcement.messageLocale.find(x => x.language == 'en').message
              : announcement.messageLocale[0].message
        })
      })
      if (p.length > 0) {
        this.openInstantLoginPopup()
      }
      console.log(p)
      return p
    },
    toDeposit() {
      if (!this.$route.params.lang) {
        return '/bank/funds'
      } else {
        return `/${this.$route.params.lang}/bank/funds`
      }
    },
    listItemToHOME() {
      if (!this.$route.params.lang) {
        return '/'
      } else {
        return `/${this.$route.params.lang}`
      }
    },

    uiHelper() {
      return uiHelper
    },
    popupAnnouncement() {
      let p = []
      let k = this.$store.state.announcement.popupAnnouncement
      k.forEach(announcement => {
        p.push({
          id: announcement.id,
          date: announcement.announcementDate,
          title:
            announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
              : announcement.titleLocale.find(x => x.language == 'en') != null
              ? announcement.titleLocale.find(x => x.language == 'en').title
              : announcement.titleLocale[0].title,
          message:
            announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
              : announcement.messageLocale.find(x => x.language == 'en') != null
              ? announcement.messageLocale.find(x => x.language == 'en').message
              : announcement.messageLocale[0].message
        })
      })
      if (p.length > 0) {
        this.openInstantPopup()
      }
      return p
    },
    hasUnreadInboxMsg() {
      return this.$store.state.inbox.inboxMsg.filter(m => !m.has_read).length > 0
    },
    grabCoin() {
      let d = this.$store.state.bonus.grabCoinSettings
      return d
    },
    wof() {
      return this.$store.state.wheel.wheel
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    loginResponseComplete() {
      return this.$store.state.member.loginResponse.complete
    },
    verifyContactResponseComplete() {
      return this.$store.state.member.verifyContactResponse.complete
    },
    changeForgotPasswordResponse() {
      return this.$store.state.member.changeForgotPassword.complete
    },
    resetPasswordResponseComplete() {
      return this.$store.state.member.resetPasswordResponse.complete
    },
    registerResponseComplete() {
      return this.$store.state.member.registerResponse.complete
    },
    forgotPasswordResponseComplete() {
      return this.$store.state.member.forgotPasswordResponse.complete
    },
    logoutResponseComplete() {
      return this.$store.state.member.logoutResponse.complete
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    vipLevel() {
      if (uiHelper.getCookie(SESSION.VIP) == null) {
        let m = this.$store.state.member.info
        let vip = m.group
        uiHelper.setCookie(SESSION.VIP, vip, 1)
        return vip
      }
      return uiHelper.getCookie(SESSION.VIP)
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    },
    vipDepositProgress() {
      return (this.vipProgress.current_deposit_progress / this.vipProgress.required_deposit_amount) * 100
    },
    vipRolloverProgress() {
      return (this.vipProgress.current_rollover_progress / this.vipProgress.required_account_rollover) * 100
    },
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    },
    languageSelected() {
      for (const lang of this.languageList) {
        if (lang.currency == this.currentCurrency) {
          // const language = lang.find(l => {
          //     // console.log('language', language);
          //     console.log('l', l);
          // });
          return `${lang.currencyCd} ${lang.currency}`
        }
      }
      return null
    }
  },
  watch: {
    facebookPixels: {
      handler(newVal) {
        if (newVal.complete && newVal.success && newVal.data) {
          this.initFacebookPixels(newVal.data)
        }
      },
      immediate: true,
      deep: true
    },
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.getInboxMsg()
        this.getLoginPopupAnnouncement()
      }
    },
    ProviderTypes() {
      this.storageGameProviderType = this.$store.state.game.ProviderTypes
    },
    memberInfo() {
      console.log(this.$store.state.member.info)
      let m = this.$store.state.member.info
      let vip = m.group
      uiHelper.setCookie(SESSION.VIP, vip, 1)
      this.currentCurrency = uiHelper.getCurrency()

      // if(this.currentLanguage != m.preferredLanguage && !uiHelper.getCookie("changeLanguage")){
      //   uiHelper.removeCookie('language')
      //   uiHelper.setCookie('language', m.preferredLanguage)
      //   this.currentLanguage = m.preferredLanguage
      //   window.location.reload()
      // }
    },
    memberWallet() {
      this.notLoading = true
    },
    changeForgotPasswordResponse() {
      //new forgotpassword flow
      let response = this.$store.state.member.changeForgotPassword
      if (response.complete) {
        try {
          this.$ga.event('Account', `Reset Password`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.updateForgotPasswordCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_UPDATE_FORGOT_PASSWORD}`)
      }
    },
    registerResponseComplete() {
      let response = this.$store.state.member.registerResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Register`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.registerResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_REGISTER_STORE}`)
      }
    },
    loginResponseComplete() {
      console.log('reach here loginResponseComplete 22222')
      let response = this.$store.state.member.loginResponse
      /* Check Path Should Reload */
      if (this.$route.fullPath == '/sportsbook/bti') {
        window.location.reload()
      }
      if (response.complete) {
        try {
          this.$ga.event('Account', `Login`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        if (response.success) {
          this.setGoogleAnalyticUserId()
          this.webpush()
        }
        this.loginResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_LOGIN_STORE}`)
        this.$store.dispatch(`${MEMBER_RESET_STORE_REG_ID}`)
        this.$store.dispatch(`${ONE_SIGNAL_PLAYER_IDS_RESET_STORE}`)
      }
    },
    logoutResponseComplete() {
      let response = this.$store.state.member.logoutResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Logout`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.logoutResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_LOGOUT_STORE}`)
      }
    },
    verifyContactResponseComplete() {
      let response = this.$store.state.member.verifyContactResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Verify Contact`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.verifyContactResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_CONTACT_VERIFICATION_STORE}`)
      }
    },
    resetPasswordResponseComplete() {
      let response = this.$store.state.member.resetPasswordResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Reset Password`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.resetPasswordResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_RESET_PASSWORD_STORE}`)
      }
    },
    forgotPasswordResponseComplete() {
      let response = this.$store.state.member.forgotPasswordResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Forgot Password`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.forgotPasswordResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_FORGOT_PASSWORD_STORE}`)
      }
    }
  },
  created() {
    this.getFacebookPixels()
    if (uiHelper.getCookie('popUpSuccessDialog')) {
      this.popUpSuccessRegister()
    }
    // const { lang } = this.$route.params;
    // const regionLocale = lang;
    //
    // // Set the language and region locale in cookies
    // this.setLanguages(value)
    // this.setRegionLocales(regionLocale)
    this.checkHasSsoToken()
    this.metaScript()
    this.initShowDownloadAPK()
    this.isAndroid()
    this.timeInterval()
    this.getPopupAnnouncement()
    this.pageDialog = this.initializePageDialogProperty()
    if (localStorage.getItem(SESSION.TOKEN)) {
      this.getMemberVipProgress()
      this.validateMemberToken()
    }
    this.setGoogleAnalyticUserId()
    this.getInboxMsg()
    this.checkReferCode()
    this.checkChannelID()
    this.$eventHub.$on('open-page-dialog', dialog => {
      this.openPageDialog(dialog)
    })
    this.$eventHub.$on('close-page-dialog', unt => {
      this.closePageDialog()
    })
    this.$eventHub.$on('open-quick-transfer-dialog', gameInfo => {
      this.openQuickTransfer(gameInfo)
    })
    this.$eventHub.$on('close-quick-transfer-dialog', dialog => {
      this.closeQuickTransferDialog()
    })
    this.$eventHub.$on('open-login-dialog', obj => {
      if (obj != null) {
        this.isTransferWalletLoginDialog = obj.isTransfer
      }
      this.openLoginDialog()
    })
    this.$eventHub.$on('close-login-dialog', dialog => {
      this.closeLoginDialog()
    })
  },
  beforeDestroy() {
    clearInterval(this.$options.validateMemberToken)
  },
  beforeCreate() {
    this.$OneSignal.getUserId(result => {
      if (result == null) {
        localStorage.removeItem('onesignal-notification-prompt')
        this.$OneSignal.showSlidedownPrompt()
      } else {
        this.oneSignal()
      }
    })
    this.$OneSignal.on('subscriptionChange', result => {
      if (result) {
        this.oneSignal()
        console.log('subscribe status ', result)
      }
    })
  },
  methods: {
    async checkChannelID() {
      const channelDbId = uiHelper.getCookie(SESSION.CHANNEL_ID)
      if (!channelDbId) return

      const guardKey = `pv_sent:${channelDbId}`
      if (sessionStorage.getItem(guardKey)) return

      // This will return the cookie if it exists, or generate+store a new one
      let fp = await uiHelper.getFingerprints()

      try {
        await this.$store.dispatch(POST_CHANNEL_PAGE_VIEW, {
          channelDbId,
          fingerprint: fp || null,
          referrer: null
        })
        sessionStorage.setItem(guardKey, '1')
      } catch (e) {
        console.log('pageview failed', e)
      }
    },
    checkReferCode() {
      let af = this.$route.query.af
      let r = this.$route.query.refer_code
      let u_s = this.$route.query.utm_source
      let u_m = this.$route.query.utm_medium
      let u_c = this.$route.query.utm_campaign
      let s1 = this.$route.query.s1
      let s2 = this.$route.query.s2
      let fbPixelId = this.$route.query.fbPixelId
      let channelID = this.$route.query.i

      try {
        let old_af = uiHelper.getCookie(SESSION.AFF_CODE)
        if (typeof old_af != 'undefined' && old_af != '' && old_af != null) {
          if (old_af !== af) {
            //if old af not match clear all pixel info.
            uiHelper.removeCookie(SESSION.PID)
            uiHelper.removeCookie(SESSION.CLICKID)
            uiHelper.removeCookie(SESSION.UTM_SOURCE)
            uiHelper.removeCookie(SESSION.UTM_MEDIUM)
            uiHelper.removeCookie(SESSION.UTM_CAMPAIGN)
            uiHelper.removeCookie(SESSION.UTM_S2)
          }
        }
      } catch (err) {
        console.log(err)
      }

      var domain = window.location.hostname
      var wwwDomain = domain.replace(/^www\./, '') // Remove "www." if it exists

      // Create a dictionary to map domains to expiration days
      var expirationDaysByDomain = {
        //first array = third party aff / second = agent code
        'bhai88.app': [30, 30],
        'bhai88.net': [30, 365],
        'bhai88.online': [30, 30],
        'bhai88.org': [30, 30],
        'bhai88.group': [30, 365],
        'bhai88.casino': [30, 30],
        'bhai88.vip': [30, 30],
        'bhai88.pro': [30, 30],
        'bhai88.com': [30, 30],
        'bhai88.club': [30, 30],
        'bhai88.live': [30, 30]
        // Add more domains and expiration days as needed
      }

      // Set the expiration day based on the domain
      var expirationDaysArray = expirationDaysByDomain[wwwDomain]

      // Default expiration (e.g., 1 day) if the domain is not in the dictionary or the array is not valid
      var expirationDaysThirdParty = 1
      var expirationDaysAgent = 365

      if (expirationDaysArray && expirationDaysArray.length === 2) {
        // Your logic to choose between short and long expiration here
        // For example, you can check some condition to decide:
        expirationDaysThirdParty = expirationDaysArray[0] // Use short expiration
        expirationDaysAgent = expirationDaysArray[1]
      }

      if (typeof u_s != 'undefined' && u_s != '' && u_s != null) {
        uiHelper.setCookie(SESSION.UTM_SOURCE, u_s, expirationDaysThirdParty)
      }
      if (typeof u_m != 'undefined' && u_m != '' && u_m != null) {
        uiHelper.setCookie(SESSION.UTM_MEDIUM, u_m, expirationDaysThirdParty)
      }
      if (typeof u_c != 'undefined' && u_c != '' && u_c != null) {
        uiHelper.setCookie(SESSION.UTM_CAMPAIGN, u_c, expirationDaysThirdParty)
      }
      if (typeof s1 != 'undefined' && s1 != '' && s1 != null) {
        uiHelper.setCookie(SESSION.UTM_S1, s1, expirationDaysThirdParty)
      }
      if (typeof s2 != 'undefined' && s2 != '' && s2 != null) {
        uiHelper.setCookie(SESSION.UTM_S2, s2, expirationDaysThirdParty)
      }
      if (typeof fbPixelId != 'undefined' && fbPixelId != '' && fbPixelId != null) {
        uiHelper.setCookie(SESSION.FB_PIXEL_CODE, fbPixelId, expirationDaysAgent)
      }
      if (typeof channelID != 'undefined' && channelID != '' && channelID != null) {
        uiHelper.setCookie(SESSION.CHANNEL_ID, channelID, 30)
      }
      if (typeof af != 'undefined' && af != '' && af != null) {
        uiHelper.setCookie(SESSION.AFF_CODE, af, expirationDaysAgent)
        this.openRegisterDialog()
      } else {
        if (typeof r != 'undefined' && r != '' && r != null) {
          uiHelper.setCookie(SESSION.REFER_CODE, r, expirationDaysAgent)
          this.openRegisterDialog()
        }
      }
    },
    popUpSuccessRegister() {
      const successResponse = {
        code: 0, // Success code
        success: true, // Registration success
        action: 'registerComplete' // Action label for the success message
      }

      // Call the registerResponseCompleteDialog method with the simulated response
      this.registerResponseCompleteDialog(successResponse)
      uiHelper.removeCookie('popUpSuccessDialog', false)
    },
    initFacebookPixels(pixelData) {
      let noscriptInserted = false

      pixelData.forEach(pixelConfig => {
        const baseDomain = pixelConfig.domain.replace(/^www\./, '')
        const domainRegex = new RegExp(`(^|\\.)?(www\\.)?${baseDomain.replace(/\./g, '\\.')}$`)
        if (domainRegex.test(window.location.hostname)) {
          if (!window.fbq) {
            ;(function(f, b, e, v, n, t, s) {
              if (f.fbq) return
              n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
              }
              if (!f._fbq) f._fbq = n
              n.push = n
              n.loaded = true
              n.version = '2.0'
              n.queue = []
              t = b.createElement(e)
              t.async = true
              t.src = v
              s = b.getElementsByTagName(e)[0]
              s.parentNode.insertBefore(t, s)
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
          }

          fbq('init', pixelConfig.fb_pixel_id)
          fbq('track', 'PageView')
          console.log(`FB Pixel loaded: ${pixelConfig.fb_pixel_id} for ${pixelConfig.domain}`)

          // ✅ Insert <noscript> only once for the first matching pixel
          if (!noscriptInserted) {
            uiHelper.setCookie(SESSION.FB_PIXEL_CODE, pixelConfig.fb_pixel_id, 30)
            const noscript = document.createElement('noscript')
            noscript.innerHTML = `<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelConfig.fb_pixel_id}&ev=PageView&noscript=1" />`
            document.body.appendChild(noscript)
            noscriptInserted = true
          }
        }
      })
    },
    getFacebookPixels() {
      this.$store.dispatch(GET_FACEBOOK_PIXEL)
    },
    async getLoginPopupAnnouncement() {
      let obj = {
        site: uiHelper.getLoginPopup(),
        type: AnnouncementType.ALL,
        page: '',
        itemsPerPage: ''
      }
      await this.$store.dispatch(`${LOGIN_POPUP_LIST}`, {
        obj
      })
    },
    openInstantLoginPopup() {
      let dayClose = uiHelper.getCookie('popupLogin')
      if (dayClose == null) {
        this.instantLoginDialogShow = true
      }
    },
    closeInstantLoginPopup() {
      let dayClose = uiHelper.getCookie('popupLogin')
      if (dayClose == null) {
        dayClose = 'yes'
      }
      uiHelper.setCookie('popupLogin', 'yes', 5)
      this.instantLoginDialogShow = false
    },
    goToClaimVoucherPage() {
      this.$router.push({
        name: ROUTE_NAME.CLAIM_VOUCHER,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    goToPromoPage() {
      this.$router.push({
        name: ROUTE_NAME.PROMOTION,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    gotoHomePage() {
      this.$router.push({
        name: ROUTE_NAME.HOME,
        params: {
          lang: this.$route.params.lang
        }
      })
      this.drawer = !this.drawer
    },
    showIntercomLC() {
      Intercom('show')
      return false
    },
    getListItemTo(gameType) {
      let routeName = ''
      switch (gameType.type) {
        case 'sb':
          routeName = ROUTE_NAME.SPORTSBOOK
          break
        case 'rng':
          routeName = ROUTE_NAME.SLOT
          break
        case 'fishing':
          routeName = ROUTE_NAME.FISHING
          break
        case 'special':
          routeName = ROUTE_NAME.SPECIAL
          break
        case 'ld':
          routeName = ROUTE_NAME.CASINO
          break
        case 'table':
          routeName = ROUTE_NAME.TABLE_GAMES
          break
        case 'lottery':
          routeName = ROUTE_NAME.LOTTERY
          break
        case 'crash':
          routeName = ROUTE_NAME.CRASH
          break
        case 'cricket':
          routeName = ROUTE_NAME.CRICKET
          break
        default:
          routeName = ROUTE_NAME.HOME
          break
      }
      if (this.$route.params.lang) {
        // If it has a value, include it in the route
        return { name: routeName, params: { lang: this.$route.params.lang } }
      } else {
        // If not, just return the route without params
        return { name: routeName }
      }
    },
    // setLanguages(lang) {
    //   // Set the language in cookies
    //   // Replace the code below with your actual implementation
    //   document.cookie = `language=${lang}; path=/;`;
    // },
    //
    // setRegionLocales(regionLocale) {
    //   // Set the region locale in cookies
    //   // Replace the code below with your actual implementation
    //   document.cookie = `regionLocale=${regionLocale}; path=/;`;
    // },
    rotateImage() {
      this.imageRotation = this.imageRotation === 'rotate(180deg)' ? 'rotate(180deg)' : 'rotate(180deg)'
      this.drawer = !this.drawer
    },
    async oneSignal() {
      let data = {
        player_ids: await this.$OneSignal.getUserId(),
        is_subscribe: await this.$OneSignal.getSubscription(),
        permission_status: await this.$OneSignal.getNotificationPermission()
      }
      await this.$store.dispatch(`${ONE_SIGNAL_PLAYER_IDS}`, { data })
    },
    webpush() {
      const regId = MTpushInterface?.getRegistrationID?.()
      if (regId) {
        this.$store
          .dispatch(`${MEMBER_STORE_REG_ID}`, { regId })
          .then(() => {
            console.log('✅ Reg ID stored:', regId)
          })
          .catch(err => {
            console.error('❌ Failed to store Reg ID:', err)
          })
      } else {
        console.warn('⚠️ regId is not available yet')
      }
    },
    checkHasSsoToken() {
      let s1 = this.$route.query.s1
      let s2 = this.$route.query.s2
      if (typeof s1 != 'undefined' && s1 != '' && s1 != null) {
        uiHelper.setCookie(SESSION.UTM_S1, s1, 1)
      }
      if (typeof s2 != 'undefined' && s2 != '' && s2 != null) {
        uiHelper.setCookie(SESSION.UTM_S2, s2, 1)
      }
      if (typeof this.$route.query.sso != 'undefined' && this.$route.query.sso != null && this.$route.query.sso != '') {
        localStorage.setItem(SESSION.TOKEN, this.$route.query.sso)
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT
        })
      }
    },
    metaScript() {
      uiHelper.setSchema(this.currentLanguage)
      const domain_all = window.location.hostname.toLowerCase()
      if (/\bbhai88.org\b/.test(domain_all)) {
        uiHelper.setMetaTag('ccpayment-site-verification', 'ab0e8f1ae39d10783b04998b643a1444')
      } else if (domain_all.includes('localhost')) {
        uiHelper.setMetaTag('ccpayment-site-verification', 'ab0e8f1ae39d10783b04998b643a1444')
        //uiHelper.removeMetaTag('ccpayment-site-verification')
      } else {
        uiHelper.removeMetaTag('ccpayment-site-verification')
      }
    },
    initShowDownloadAPK() {
      this.showDownloadAPK = true
    },
    hideDownloadBar() {
      this.showDownloadAPK = false
    },
    refreshCurrentState() {
      this.$router.push({
        name: ROUTE_NAME.HOME,
        params: {
          lang: this.$route.params.lang
        }
      })
      this.$forceUpdate()
    },
    downloadAPK() {
      uiHelper.downloadAPK()
    },
    isAndroid() {
      try {
        let isAndroid = AndroidFunction.isMobile() ?? false
        uiHelper.setLocalStorage(CACHE_KEY.IS_ANDROID, isAndroid, 60)
      } catch (e) {
        uiHelper.setLocalStorage(CACHE_KEY.IS_ANDROID, false, 60)
      }
    },
    timeInterval() {
      let gmt = moment
        .parseZone()
        .toString()
        .slice(-8)
      gmt = gmt.substring(0, 4) + gmt.substring(5, 6) + ':' + gmt.substring(6, 8)
      setInterval(() => {
        this.time = `(${gmt}) ${moment()
          .utcOffset(0, true)
          .format('HH:mm:ss')}`
      }, 1000)
    },
    async getPopupAnnouncement() {
      let obj = {
        site: uiHelper.getPopup(),
        type: AnnouncementType.ALL,
        page: '',
        itemsPerPage: ''
      }
      await this.$store.dispatch(`${POPUP_LIST}`, {
        obj
      })
    },
    openInstantPopup() {
      let dayClose = uiHelper.getCookie('popup')
      if (dayClose == null) {
        this.instantDialogShow = true
      }
    },
    closeInstantPopup() {
      let dayClose = uiHelper.getCookie('popup')
      if (dayClose == null) {
        dayClose = 'yes'
      }
      uiHelper.setCookie('popup', 'yes', 0.5)
      this.instantDialogShow = false
    },
    getInboxMsg() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${INBOX_GET_MSG}`)
      }
    },

    getGrabCoinSetting() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${GRAB_COIN_SETTING}`, {
        filter
      })
    },
    checkShouldHideCoin() {
      if (typeof uiHelper.getCookie(SESSION.HIDE_COIN) != 'undefined' && uiHelper.getCookie(SESSION.HIDE_COIN) == 1) {
        this.showCoin = false
      } else {
        this.showCoin = true
      }
    },
    getWOF() {
      let currency = uiHelper.getCurrency()
      let filter = {
        currency: currency
      }
      this.$store.dispatch(`${WHEEL_MODULE}`, {
        filter
      })
    },
    checkShouldHideAngpao() {
      if (typeof uiHelper.getCookie(SESSION.HIDE_ANG_PAO) != 'undefined' && uiHelper.getCookie(SESSION.HIDE_ANG_PAO) == 1) {
        this.showAngpao = false
      } else {
        this.showAngpao = true
      }
    },
    dontShowMeAgain() {
      this.showAngpao = false
      uiHelper.setCookie(SESSION.HIDE_ANG_PAO, 1, 0.5)
    },
    navigateToAngpao() {
      this.$router.push({
        name: ROUTE_NAME.REWARDS_BY_TYPE,
        params: {
          type: 'angpao'
        }
      })
    },
    setGoogleAnalyticUserId() {
      if (this.memberInfo.memberCode != '') this.$ga.set('userId', this.memberInfo.memberCode)
    },
    openLiveChat() {
      try {
        this.$ga.event('Live Chat', `Open`, `Open Live Chat`)
      } catch (err) {
        console.log(err)
      }
      window.open('/livechat', 'Live Chat', 'width=350,height=600')
    },
    goToTransferPage() {
      this.$router.push({
        name: ROUTE_NAME.TRANSFER
      })
    },
    goToWithdrawalPage() {
      this.$router.push({
        name: ROUTE_NAME.WITHDRAWAL
      })
    },
    goToDepositPage() {
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT,
        params: { lang: this.$route.params.lang }
      })
    },
    goToProfilePage() {
      this.$router.push({
        name: ROUTE_NAME.PERSONAL,
        params: { lang: this.$route.params.lang }
      })
    },
    goToInboxPage() {
      this.$router.push({
        name: ROUTE_NAME.INBOX,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    validateMemberToken() {
      if (new Date(parseInt(localStorage.getItem(SESSION.TOKEN_EXPIRY))) - new Date() < 60000) {
        if (new Date() - new Date(parseInt(localStorage.getItem(SESSION.LAST_ACTIVITY_TIME))) > 10800000) {
          const logoutObj = {}
          let sessionTimedOut = true
          this.$store.dispatch(MEMBER_LOGOUT, {
            logoutObj,
            sessionTimedOut
          })
        } else {
          this.$store.dispatch(MEMBER_REFRESH_TOKEN)
        }
      } else {
        let requiredLoading = false
        this.$store.dispatch(MEMBER_CHECK_TOKEN_VALIDITY, {
          requiredLoading
        })
      }
    },
    memberContactVerification(memberCode, otp, type, contact) {
      let verificationObj = {
        memberCode: memberCode,
        otp: otp,
        type: type,
        contact: contact
      }
      this.$store.dispatch(MEMBER_CONTACT_VERIFICATION, {
        verificationObj
      })
    },
    logout() {
      const logoutObj = {
        domain: uiHelper.getHostname(),
        platform: uiHelper.getPlatform()
      }
      let sessionTimedOut = false
      this.$store.dispatch(MEMBER_LOGOUT, {
        logoutObj,
        sessionTimedOut
      })
    },
    maskBalance() {
      this.showBalance = !this.showBalance
    },
    getMemberWallet() {
      const lastDispatchTime = sessionStorage.getItem('lastDispatchTime')

      if (!lastDispatchTime || Date.now() - parseInt(lastDispatchTime) > 15 * 1000) {
        this.notLoading = false
        sessionStorage.setItem('lastDispatchTime', Date.now()) // Update last dispatch time in sessionStorage
        this.$store.dispatch(MEMBER_WALLET)
      }

      this.maskBalance()
    },
    getMemberVipProgress() {
      this.$store.dispatch(MEMBER_GET_VIP_PROGRESS)
    },
    /* DIALOG */
    closeRegisterSuccessDialog() {
      this.registerSuccessDialogShow = false
    },
    closeNewRegisterDialogShow() {
      this.newRegisterDialogShow = false
    },
    closeQuickTransferDialog() {
      this.quickTransferDialogShow = false
      let routeData = this.$router.resolve({
        name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
        params: {
          provider: this.ptGameInfo.provider,
          type: this.ptGameInfo.type,
          lang: this.$route.params.lang
        },
        query: {
          id: this.ptGameInfo.id,
          code: this.ptGameInfo.code,
          demo: 0
        }
      })
      try {
        this.$ga.event('Game', `${0 ? 'Demo' : 'Real'} Play`, `${this.ptGameInfo.provider.toUpperCase()} - Slot - ${this.ptGameInfo.locale.find(x => x.language == 'en').name}`, this.ptGameInfo.id)
      } catch (err) {
        console.log(err)
      }
      uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
    },
    openRegisterDialog() {
      this.registerDialogShow = true
      this.closeWaitRegisterDialog()
      this.closeLoginDialog()
      this.closeForgotPasswordDialog()
      try {
        srtmCommands.push({
          event: 'track.user.registration',
          payload: {
            action: 'start'
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    openRegister() {
      // this.openRegisterDialog()
      this.closeWaitRegisterDialog()
      this.closeLoginDialog()
      this.closeForgotPasswordDialog()
      this.$router.push({ name: ROUTE_NAME.REGISTER })
      // this.$router.push({
      //     name: ROUTE_NAME.REGISTER
      // })
    },
    // openRegisterDialog() {
    //   // this.registerDialogShow = true
    //   this.closeWaitRegisterDialog()
    //   this.closeLoginDialog()
    //   this.closeForgotPasswordDialog()
    //   this.$router.push({name: ROUTE_NAME.REGISTER})
    // },
    closeRegisterDialog(actionFromRegisterDialog = true) {
      this.registerDialogShow = false
      this.$store.dispatch(`${MEMBER_RESET_SMS_VERIFICATION}`)
      // if (this.firstTimeRegister && actionFromRegisterDialog) {
      //   this.openWaitRegisterDialog()
      //   this.firstTimeRegister = false
      // }
    },
    // openLoginDialog() {
    //   this.loginDialogShow = true
    //   this.closeWaitRegisterDialog()
    //   this.closeRegisterDialog(false)
    // },
    closeLoginDialog() {
      if (this.isTransferWalletLoginDialog) {
        this.$router.push({
          name: ROUTE_NAME.SLOT_BY_PROVIDER,
          params: {
            provider: 'all',
            lang: this.regionLocale
          }
        })
      }
      this.loginDialogShow = false
    },
    openForgotPasswordDialog() {
      this.forgotPasswordDialogShow = true
      this.closeLoginDialog()
    },
    closeForgotPasswordDialog() {
      this.forgotPasswordDialogShow = false
    },
    openResetPasswordDialog(memberCode, contact) {
      this.resetPasswordObj.memberCode = memberCode
      this.resetPasswordObj.contact = contact
      this.closeForgotPasswordDialog()
      this.resetPasswordDialogShow = true
    },
    closeResetPasswordDialog() {
      this.resetPasswordObj.memberCode = ''
      this.resetPasswordObj.contact = ''
      this.resetPasswordDialogShow = false
    },
    openLanguageDialog() {
      this.languageDialogShow = true
    },
    goToVideoGuidePage() {
      this.$router.push({
        name: ROUTE_NAME.VIDEO_GUIDE,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    closeLanguageDialog() {
      this.languageDialogShow = false
    },
    openLoginDialog() {
      this.drawer = false
      this.loginDialogShow = true
      this.closeForgotPasswordDialog()
      this.closeWaitRegisterDialog()
      this.closeRegisterDialog(false)
    },
    openQuickTransfer(gameInfo) {
      this.ptGameInfo = gameInfo
      this.quickTransferDialogShow = true
      this.transferToProvider = gameInfo.provider == 'pt' ? 'PT' : 'MAIN'
      this.transferMessage = locale.getMessage(`label.ptQuickTransfer`, [this.transferToProvider])
    },
    openProfileSheet() {
      this.showProfileSheet = true
    },
    closeProfileSheet() {
      this.showProfileSheet = false
    },
    openPageDialog(dialog) {
      this.pageDialog = dialog
      this.pageDialogShow = true
    },
    closeTimeOutDialog() {
      localStorage.removeItem(SESSION.TOKEN)
      this.closePageDialog()
      this.refreshCurrentState()
    },
    closePageDialog() {
      this.showProfileSheet = false
      this.pageDialogShow = false
      this.initializePageDialogProperty()
    },
    openWaitRegisterDialog() {
      this.waitRegisterDialogShow = true
    },
    closeWaitRegisterDialog() {
      this.waitRegisterDialogShow = false
    },
    /* RESPONSE COMPLETE DIALOG */
    loginResponseCompleteDialog(response) {
      let currentPage = this.$route.name
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`) + ' Error'
      if (response.code != 0 && !response.success) {
        this.loginErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
        console.log(this.loginErrorMsg)
      } else {
        this.closeLoginDialog()
        this.currentCurrency = uiHelper.getCurrency()
        this.closeRegisterDialog(false)
        if (currentPage == this.routeName.LOGIN) {
          this.$router.push({
            name: ROUTE_NAME.HOME
          })
        }
      }
    },
    logoutResponseCompleteDialog(response) {
      if (response.isSessionTimedOut) {
        this.$router.push({
          name: ROUTE_NAME.HOME
        })
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.${response.action}`)
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closeTimeOutDialog
        })
        this.openPageDialog(dialog)
      }
    },
    forgotPasswordResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        dialog.message.push(locale.getMessage(`message.forgotPasswordSendText`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: this.closePageDialog
        })
        this.closeForgotPasswordDialog()
      }
      this.openPageDialog(dialog)
    },
    updateForgotPasswordCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.resetPassword`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        let self = this
        dialog.message.push(locale.getMessage(`message.resetPasswordComplete`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: self.closeResetPasswordSuccessDialog
        })
      }
      this.closeResetPasswordDialog()
      this.openPageDialog(dialog)
    },
    resetPasswordResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        let self = this
        dialog.message.push(locale.getMessage(`message.resetPasswordComplete`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: self.closeResetPasswordSuccessDialog
        })
      }
      this.closeResetPasswordDialog()
      this.openPageDialog(dialog)
    },
    closeResetPasswordSuccessDialog() {
      let self = this
      this.closePageDialog()
      setTimeout(function() {
        window.location.reload()
      }, 1)
    },
    registerResponseCompleteDialog(response) {
      console.log('reach registerResponseCompleteDialog')
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
        this.openPageDialog(dialog)
        this.registerErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
      } else {
        this.registerSuccessDialogShow = true
        // let vm = this
        // setTimeout(function() {
        //   // this.registerSuccessDialogShow = false
        //   vm.$router.push({
        //     name: ROUTE_NAME.DEPOSIT
        //   })
        //   vm.newRegisterDialogShow = true
        // }, 5000)
      }
    },
    verifyContactResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        dialog.message.push(locale.getMessage(`message.contactVerificationComplete`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: this.closePageDialog
        })
      }
      this.closeResetPasswordDialog()
      this.openPageDialog(dialog)
    }
  }
}
</script>

<style lang="scss">
.mt_webpush_preivew .preview-inner .modal-title {
  color: #fff !important;
}
.mt_webpush_preivew .preview-inner .modal-content {
  color: #fff !important;
}
.mt_webpush_preivew .preview-inner .modal-subtitle {
  color: #fff !important;
}
.mt_webpush_preivew .preview-inner .entry-btn {
  background: #e900bd !important;
  color: #fff !important;
}
.mt_webpush_preivew .preview-inner .modal {
  background-color: #641880 !important;
  z-index: 1 !important;
}
.side-navigation-divider {
  background: #322c44;
  width: 98%;
  max-height: 3px;
  height: 3px;
  margin: auto;
}
.mobile-top::before {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, #b327ae00 0%, #ff5ae4 48%, #b327ae00 100%);
}
.mobile-balance-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  background-color: #322c44;
  border-radius: 15px;
  color: white;
}
.side-navigation-banner-button {
  background-color: #ffc000 !important;
  border-radius: 5px;
  width: 100%;
  color: #3d004f;
}
.side-navigation-banner {
  padding: 25px 35px;
  background: linear-gradient(180deg, #1c1632 0%, #3d004f 50%, #1c1632 100%);
}
.side-navigation-banner-login {
}
.side-navigation-banner-login::before {
  content: '';
  position: absolute;
  top: 72px;
  left: 0;
  width: 100%;
  height: 4px; /* Height of the gradient border */
  background: linear-gradient(270deg, #b327ae00 0%, #ff5ae4 48%, #b327ae00 100%);
}
.side-navigation-banner::before {
  content: '';
  position: absolute;
  top: 72px;
  left: 0;
  width: 100%;
  height: 4px; /* Height of the gradient border */
  background: linear-gradient(270deg, #b327ae00 0%, #ff5ae4 48%, #b327ae00 100%);
}
.starterPackTextSmall {
  font-size: 12px;
}
.starterPackText {
  font-size: 18px;
}
.breakWord-onspace {
  white-space: normal;
}

.vip-badge-mobile {
  .v-badge {
    margin-top: 11px;
  }
}

.v-btn--is-elevated {
  box-shadow: 0px 0px !important;
}

.coin_box_gif {
  position: fixed;
  bottom: 32%;
  right: 10px;
  z-index: 200;
  cursor: pointer;
}

.grab_coin_icon {
  animation: swing 1.2s;
  animation-iteration-count: 3;
}

@keyframes swing {
  20% {
    transform: rotate(15deg);
  }

  40% {
    transform: rotate(-10deg);
  }

  60% {
    transform: rotate(5deg);
  }

  80% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

// .v-badge__badge {
//   bottom: 14px !important;
// }

.language_desktop {
  position: absolute;
  top: 70px;
  right: 3.5%;
}

.icon_middle_nav {
  width: 30px;
  stroke: white;
  fill: white;
}

.icon_btm_nav {
  width: 24px;
  height: 24px;
  margin-top: 8px;
  //stroke: #fff;
  fill: var(--v-text_color-base);

  &.chat {
    stroke: white;
    fill: white;
    width: 23px;
    margin-bottom: -8px;
  }

  &.depo_icon_btm_nav {
    height: 40px;
    width: 42px;
  }
}

.icon_normal {
  width: 25px;
  fill: white;
  color: black;
  stroke: #e4282f;
}

.icon_large {
  width: 35px;
  fill: white;
  color: black;
  margin-top: -5px;
}

.gold-gradient {
  background: transparent linear-gradient(180deg, #ffa15c 0%, #e2d200 100%) 0% 0% no-repeat padding-box;
  font-weight: bold;
}

.btn_img_lc {
  width: 30px;
  padding-bottom: 0;
  padding-left: 5px;
  margin-left: 10px;
}

.gold-color {
  background-color: #b87953 !important;
}

.yellow-color {
  background-color: #fddd04 !important;
}

.v-btn.theme-button.liveChatButton {
  background: #8d1cff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000080;
  opacity: 1;
}

.mobile-member-info-box {
  padding: 5px 15px;
  background: #121734;
  box-shadow: 0px 3px 6px #00000042;
  border-radius: 8px;

  .mobile-member-info-box-text {
    font-size: 15px;
  }

  .mobile-member-info-box-text-icon {
    font-size: 12px;
  }

  .mobile-member-info-box-balance {
    font-size: 15px;
    font-weight: bold;
  }

  .mobile-member-info-box-icon {
    height: auto !important;

    .v-icon {
      font-size: 28px;
    }
  }
}

.ChatButton {
  width: 200px;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  z-index: 1;
  min-height: auto !important;
  position: fixed;
  height: auto;
  top: 30%;
  right: -80px;
  transform: rotate(-90deg);

  span {
    font-size: 24px;
    font-weight: normal;
  }
}

.header-row {
  display: flex;
  flex-direction: column;
  padding-left: 1em;
  padding-right: 1em;
}

button {
  &.round {
    border-radius: 50% !important;
  }

  &.buttonWhite {
    box-shadow: none;
  }

  span {
    letter-spacing: 0;
  }
}

.v-btn.primary-button {
  border-radius: 10px;
  color: black;
  text-transform: capitalize; // border-radius: 25px;
  width: 100%;
  font-size: 16px;
}

.sticky-header {
  position: sticky;
  top: 0;
}

.brand-logo {
  position: absolute;
  left: 3%;
  transform: translateX(-3%);
  z-index: 1;
  top: -1%;
  width: 300px;
  margin-top: 20px;
}

.mobile-brand-logo {
  width: 250px;
}

.img_flag_select {
  width: 23px;
  height: 17px;
  margin-left: -10px;
  margin-right: 4px;
}

.member-menu-divider {
  border-color: white !important;
}

.div_header {
  background-color: #2d3487;
  padding-top: 20px;
}

.splitter_header {
  padding: 0;
  background-color: #3a3eb1;
  margin: 0 auto;
}

.header-icon-button-link {
  height: 40px !important;
  min-width: auto !important;
  width: 40px !important;
  margin-left: 8px;
}

.header-icon-button-more {
  height: 40px !important;
}

.status-bar {
  position: fixed;
  z-index: 5;
  height: 30px;
  width: 100%;
  background-color: var(--v-base-base);
  font-size: 14px;

  .status-bar-wrapper {
    width: 100%;
    max-width: 1240px;
    margin: auto;
  }

  .status-bar-language {
    .v-btn {
      background: rgba(255, 255, 255, 0.3);
      height: auto;
    }

    .v-btn:hover {
      background-color: rgba(13, 84, 62, 1);
    }

    .v-btn__content {
      text-transform: capitalize;
    }
  }

  .status-bar-icon {
    display: flex;
    position: relative;
    //color: #d5d5d5;
    color: var(--v-text_color-darken2);
    padding: 0px 8px;
    cursor: pointer;

    i {
      padding: 0px 4px 0px 0px;
      //color: #d5d5d5;
      color: var(--v-text_color-darken2);
    }

    .v-image {
      margin-right: 4px;
    }
  }

  .status-bar-icon:hover {
    //color: #ffffff;
    color: var(--v-text_color-lighten1);

    i {
      //color: #ffffff;
      color: var(--v-text_color-lighten1);
    }
  }

  .status-bar-icon:not(:last-child)::before {
    content: '';
    position: absolute;
    top: 20%;
    right: 0;
    width: 1px;
    height: 60%;
    border-right: 1px solid var(--v-text-base);
    opacity: 0.8;
  }
}

.download-bar {
  position: fixed;
  z-index: 5;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0px 12px;
  background-color: #f5f5f5;
  line-height: 1;

  .download-bar-button {
    background: #ffc000 !important;
    color: #322c44;
  }
}

.download-bar-height {
  margin-top: 60px;
}

.download-bar-height-body {
  margin-top: 118px;
}

.header-top {
  height: 80px;
  background: transparent linear-gradient(181deg, #1c1632 0%, #000000 100%) 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000052 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 5;

  .v-toolbar__content {
    max-width: 1240px;
    width: 100%;
    margin: auto;
    padding: 0px;
  }

  .theme--dark.v-btn.v-btn--icon {
    color: var(--v-text_reverse-base);
  }
}

.header-column {
  color: var(--v-text_reverse-base);

  .is-login-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .btn-icon {
    margin: 0 2px;
    cursor: pointer;
  }

  .header-divider {
    width: 1px;
    height: 32px;
    margin: 0 4px;
    background-color: white;
  }

  .refresh-balance {
    transition: transform 0.5s;
  }

  .refresh-balance:hover {
    transform: rotate(215deg);
  }

  .invisible-button {
    height: 1.5rem;
    min-width: 120px;
    padding: 4px 12px;
    cursor: pointer;
    opacity: 1;

    .v-btn__content {
      opacity: 1 !important;
    }

    label {
      cursor: pointer;
    }
  }

  .invisible-button:hover {
    border: 1px solid #ff5ae4;
    border-radius: 8px;
  }
}

.account-actions {
  display: flex;

  a {
    margin-left: 5px;
    margin-right: 5px;
    text-decoration: none;
  }

  .flex-column {
    padding-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 12px;

    img {
      height: 35px;
    }
  }
}

.login-form .v-messages__message {
  font-size: 9px !important;
}
.bottom-navigator-text {
  height: 45%;
  font-size: 13px;
}
.header-bottom {
  min-height: 100px;
  color: #ffffff;
  background: transparent linear-gradient(180deg, #4145c4 0%, #121734 150%) 0% 0% no-repeat padding-box;
  position: sticky;
  top: 0;
  z-index: 15;
}

.side-navigation-drawer {
  $side-nav-p: 0px 10px;
  .v-navigation-drawer__content {
    background-color: #1c1632;
  }

  .list-item-container {
    padding: $side-nav-p;
  }

  .side-nav-logo {
    background: transparent linear-gradient(180deg, #1c1632 0%, #000000 100%);
    padding: 12px 12px;
    margin: 0px !important;
    border-radius: 0px !important;
    justify-content: space-around;
  }

  .v-list {
    padding: 0px;
  }

  .v-list-item__title {
    color: #fff;
  }

  a {
    margin: 0px !important;

    &.v-list-item,
    &.v-list-item--link {
      border-radius: 0;
    }

    &.v-list-item::before,
    &.v-list-item--link::before {
      border-radius: 0;
    }

    &.v-list-item--active {
      //color: #ffffff !important;
      //background-color: var(--v-secondary-base);
    }
  }

  .mobile_list_menu {
    .v-list-item__icon {
      margin: 0;
    }
  }

  .v-list-item__icon:first-child {
    margin-right: 12px 0;
  }

  .side-menu-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .side-menu-icon {
    width: 36px;
    height: 36px;
  }

  .side-menu-bottom {
    width: 30px;
    height: 30px;
  }

  .v-list-item-bottom {
    padding-left: 7px;
  }

  .vip-progress-bar {
    .v-progress-linear__background {
      background-color: #ebebeb !important;
      border-color: #ebebeb !important;
      opacity: 1 !important;
    }

    .v-progress-linear__determinate {
      border-radius: 10px;
    }

    label {
      color: #acacac;
    }
  }
}

.bottom-navigator {
  position: fixed;
  bottom: 0;
  z-index: 4;
  width: 100%;
  background: transparent linear-gradient(180deg, #7d1982 0%, #1c1632 100%);
  font-size: 13px;

  .bottom-navigation-center-button {
    margin-top: -32px;
    width: 75px;
    height: 75px;
    border-radius: 50%;
    background: #ffc000;
    box-shadow: 0px 5px 8px #00000080;
    color: #fff;
    text-align: center;
    //box-shadow: 0px 1px 6px rgb(0 0 0 / 42%);
    cursor: pointer;
  }

  .bottom-navigator-before-login {
    height: 60px;
    background: transparent linear-gradient(180deg, #0047ff 0%, #361dd2 47%, #5a00b4 100%) 0% 0% no-repeat padding-box;

    .bottom-navigator-before-login-first {
      color: black;
      background-color: #d8d8d8;
      border: 1px solid #ddd;
    }

    .bottom-navigator-before-login-second {
      color: white;

      font: normal normal 600 16px/25px Poppins !important;

      background: transparent linear-gradient(180deg, #ffab2d 0%, #ff7700 100%) 0% 0% no-repeat padding-box;
    }

    .bottom-navigator-before-login-third {
      color: white;
      font: normal normal 600 16px/25px Poppins !important;
      background: transparent linear-gradient(180deg, #0047ff 0%, #361dd2 47%, #5a00b4 100%) 0% 0% no-repeat padding-box;
    }
  }

  .theme--light.v-btn.v-btn--has-bg {
    background-color: transparent;
  }

  a {
    //height: 50px !important;
    letter-spacing: 1px;
    padding: 0 !important;
    display: block;
    border-color: var(--v-base_3-base);
    text-decoration: none;

    &::before {
      opacity: 0 !important;
    }

    // &.link-active {
    //   border-color: #8C8CDB;
    //   .icon_btm_nav {
    //     fill: #8C8CDB;
    //     stroke: #8C8CDB;
    //     ;
    //   }
    //   .v-icon {
    //     color: #8C8CDB;
    //   }
    //   p {
    //     color: #8C8CDB;
    //   }
    // }
    p {
      margin: -2px 0 0 0;
      text-transform: capitalize;
      color: white;
    }
  }
}

.mobile-header-detail {
  // margin-top: 36px !important;
  background-color: #fff;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 12px;
  min-height: 46px;

  .header-wallet {
    font-size: 14px;
    padding: 15px 35px 15px 15px;
  }

  .header-wallet-icon {
    margin-left: -25px;
  }
}

.mobile-header-rightBtns {
  justify-content: flex-end;
}

@media (max-width: 1499px) {
  .div_header {
    padding-top: 0;
  }

  .language_desktop {
    top: 60px;
    right: 4%;
  }
}

@media (max-width: 1263px) {
  .language_desktop {
    right: 6%;
  }

  .header-icon-button-link {
    height: 35px !important;
    width: 35px !important;
    margin-left: 4px;
  }

  .header-icon-button-more {
    height: 35px !important;
    margin-left: 4px;
    min-width: auto !important;
    width: 30px !important;

    .v-icon {
      height: 15px !important;
      font-size: 28px !important;
    }
  }

  .header-text {
    font-size: 13px !important;
  }
}

@media (max-width: 1024px) {
  .header-text-statis-word {
    display: none;
  }
}

@media (max-width: 599px) {
  .header-top {
    height: 60px;
    // background: var(--v-primary-base) !important;

    .v-toolbar__content {
      height: 60px !important;
      padding: 4px 16px;
    }

    .toolbar-icon {
      color: var(--v-text_reverse-base);
    }
  }

  .v-btn.primary-button {
    font-size: 12px;
    width: 100%;
  }

  .language_desktop {
    position: absolute;
    top: 50px;
    right: 13%;
  }

  .liveChatButton {
    display: none;
  }

  .header {
    height: 50px;
    background-image: linear-gradient(to right, var(--v-primary-base), var(--v-primary_3-base));
    padding: 0 15px;

    .mobile-brand-logo {
      width: auto !important;
      height: 25px !important;
      margin-top: 5px;
    }

    .header-mobile-livechat {
      position: absolute;
      top: 0;
      right: 15px;
      height: 100%;

      .v-icon {
        font-size: 25px;
        padding-right: 5px;
      }

      .v-btn__content {
        font-size: 16px;
      }
    }
  }

  .v-btn.v-size--default {
    font-size: 14px;
  }
  .v-btn.v-btn--icon.v-size--default {
    width: 40px !important;
  }
}

@media (max-width: 599px) {
  .header {
    padding: 0 15px;

    .header-mobile-livechat {
      .v-icon {
        font-size: 25px;
      }

      .v-btn__content {
        font-size: 16px;
      }
    }
  }

  .mobile-brand-logo {
    margin-top: -10px;
    margin-left: -10px;
    width: 200px;
  }

  .profile-alert-success {
    font-size: 14px;
  }

  .profile-alert-failed {
    font-size: 14px;
  }

  .bottom-navigator {
    background-color: #ff7700;

    .v-btn.v-btn--has-bg {
      background: transparent;

      .v-btn__content {
        font-size: 12px;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }
  }
}

@media (max-width: 410px) {
  .middledeposit {
    height: 57% !important;
  }
  .bottom-navigator {
    background-color: #ff7700;

    .v-btn.v-btn--has-bg {
      background: transparent;

      .v-btn__content {
        font-size: 10px;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }
  }
  .bottom-navigator-text {
    font-size: 10px;
  }
}
@media (max-width: 340px) {
  .bottom-navigator {
    background-color: #ff7700;

    .v-btn.v-btn--has-bg {
      background: transparent;

      .v-btn__content {
        font-size: 8px;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }
  }
  .bottom-navigator-text {
    font-size: 8px;
  }
}

.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(4, end) 900ms infinite;
  animation: ellipsis steps(4, end) 900ms infinite;
  content: '\2026';
  /* ascii code for the ellipsis character */
  width: 0px;
}

@keyframes ellipsis {
  to {
    width: 20px;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 20px;
  }
}
.secBox {
  display: flex;
  flex-wrap: wrap;
  text-transform: none;
  justify-content: space-evenly;
  height: 100%;
  gap: 10px 0px;
  margin: 10px;
  .sidenav {
    background: #322c44;
    border-radius: 5px !important;
    width: 45% !important;
    height: 40px !important;
    min-width: 45% !important;
    max-width: 45% !important;
  }
  .v-list-item__title {
    color: #fff;
    padding-left: 10px;
  }
  &item {
    flex: 1;
    width: calc(33.33%);
    //max-width: 33%;
    margin: 10px;
    padding: 10px;
    width: 100px !important;
    height: 42px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }
}

.box {
  display: flex;
  flex-wrap: wrap;
  text-transform: none;
  justify-content: space-evenly;
  //justify-content:flex-start;
  //align-items: stretch;
  height: 100%;
  margin: 10px;
  gap: 10px 0px;
}

.box item {
  flex: 1;
  width: calc(33.33%);
  //max-width: 33%;
  margin: 10px;
  padding: 10px;
  width: 100px !important;
  height: 42px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.sidenav {
  background: #322c44;
  border-radius: 5px !important;
  width: 28% !important;
  height: 80px !important;
  min-width: 80px !important;
  max-width: 28% !important;
  padding-bottom: 10px;
}

.step-display {
  margin-top: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2em;
  > .step {
    color: white;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;

    &.active {
      color: black;

      > span {
        background-color: #ffc000;
      }
    }

    > span {
      display: block;
      text-align: center;
      padding: 6px 12px;
      border-radius: 4px;
      background-color: #3d3360;
      width: 32px;
      height: 32px;
      &.material-icons {
        padding: 4px;
      }
    }

    &:not(:nth-child(1)) {
      &:before {
        content: '';
        display: inline-block;
        background-color: #3d3360;
        width: 28px;
        height: 6px;
      }
    }
  }
}
</style>
